import api from "../index";
import { apiUrl, constant } from "../../utils/constants";

export const GetTeams = (params) => api.get(`${constant.V1}${apiUrl.teams}/`, { params })
export const GetSingleTeam = (id) => api.get(`${constant.V1}${apiUrl.teams}/${id}/`)
export const EditTeam = (id, data) => api.put(`${constant.V1}${apiUrl.teams}/${id}/`, data)
export const DeleteTeamUser = (id) => api.delete(`${constant.V1}${apiUrl.teams}${apiUrl.members}/${id}/`)
export const BulkDeleteTeamUser = (ids) => api.delete(`${constant.V1}${apiUrl.teams}${apiUrl.members}/${apiUrl.bulk_delete}/`, { data: { ids } })
